import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from "@angular/common/http";
import { ToastService } from 'src/app/services/toast.service';
import { StorageService } from 'src/app/services/storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CustomerService extends MainService {

	customer: any = null;

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router,
	) {
		super(http, toastService, storage, router);
	}

	getLogedInCustomer(){
		return new Promise(res => {
			this.makeRequest('/rest/entrelable/V1/customers/me', null, 'GET').then(resolve => {
				this.customer = resolve;
				res(resolve);
			});
		});
	}

	setAsDefaultAddress(address:any, isMakeRequest:boolean=true){
		this.customer.addresses.forEach((val, key) => {
			if(val.id == address.id){
				val['default_shipping'] = true;

				// Set default address when checked
				let addressId = val.id;
				let customerId = address.customer_id;
				if(isMakeRequest){
					let url = this.getStoreUrl('/V1/lns-api/customer/address/'+ addressId + '/' + customerId +'/'+'setdefaultaddress');
					this.makeRequest(url, null, 'POST').then(_address => {});
				}
			} else {
				val['default_shipping'] = false;
			}
		});
	}

	deleteAddress(address, socketioService:any=null){
		return new Promise(resolve => {
			if(address.default_shipping){
				if(this.customer.addresses.length > 1){

					let isFoundNewDefault = false;
					this.customer.addresses.forEach((val, key) => {
						if(!val.default_shipping && !isFoundNewDefault){
							let url = this.getStoreUrl('/V1/lns-api/customer/address/'+ val.id + '/' + val.customer_id +'/'+'setdefaultaddress');
							this.makeRequest(url, null, 'POST').then(_address => {
								this.setAsDefaultAddress(val, false);
								this.deleteAddressHelper(address, socketioService).then(isDeleted => {
									resolve(isDeleted);
								});
							});
							isFoundNewDefault = true;
						}
					});
				} else {
					this.toastService.add('Cannot delete because you only have 1 address.', 'danger');
					resolve(false);
				}
			}
			else {
				this.deleteAddressHelper(address, socketioService).then(isDeleted => {
					resolve(isDeleted);
				});
			}
		});

  	}
	
	deleteAddressHelper(address, socketioService:any=null){
		return new Promise(resolve => {
			const addToRemove = address;
			this.setLoader(true);
			let url = this.getStoreUrl('/V1/lns-api/customer/address/'+addToRemove.id+'/delete');
			this.makeRequest(url, '', 'DELETE', false).then(deleteAdd => {
				if(deleteAdd){	
					if(socketioService){
						socketioService.emitToSelf('checkout_delete_address', addToRemove);
					}
					this.removeAddressToList(addToRemove);
					this.setLoader(false);
					resolve(true);
				}
				else {
					resolve(false);
				}
			});
		});
	}

	removeAddressToList(address:any=null){
		this.getLogedInCustomer();
	}
}
